import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { PHOTOS_BASE_QUERY_KEY } from 'components/domain/property/useFetchPhotos';
import { PHOTO_ORDER_MUTATION_KEY } from '../components/photoGrid/usePhotoReorder';
import { UPLOAD_PHOTO_MUTATION_KEY } from '../components/upload/useUploadPhotos';
import { UPDATE_PHOTO_MUTATION_KEY } from '../components/photoGrid/modals/usePhotoMutation';
import { DELETE_SELECTED_PHOTOS_MUTATION_KEY } from '../components/selectMode/useDeleteSelectedPhotos';
import { DELETE_PHOTO_MUTATION_KEY } from './useDeletePhoto';

const usePhotoMutationStatus = () => {
  const updatingPhotoOrderCount = useIsMutating({
    mutationKey: PHOTO_ORDER_MUTATION_KEY,
  });
  const uploadingPhotosCount = useIsMutating({
    mutationKey: UPLOAD_PHOTO_MUTATION_KEY,
  });
  const deletingPhotoCount = useIsMutating({
    mutationKey: DELETE_PHOTO_MUTATION_KEY,
  });
  const isFetchingPhotos = useIsFetching({
    queryKey: [PHOTOS_BASE_QUERY_KEY, 'get-all'],
  });
  const updatingPhotoCount = useIsMutating({
    mutationKey: UPDATE_PHOTO_MUTATION_KEY,
  });
  const deletingSelectedPhotosCount = useIsMutating({
    mutationKey: DELETE_SELECTED_PHOTOS_MUTATION_KEY,
  });

  const isUpdatingPhotos =
    updatingPhotoOrderCount > 0 ||
    uploadingPhotosCount > 0 ||
    deletingPhotoCount > 0 ||
    deletingSelectedPhotosCount > 0;

  const isRefetchingPhotos = isFetchingPhotos > 0;

  const isUpdatingSinglePhoto = updatingPhotoCount > 0;

  return { isUpdatingPhotos, isRefetchingPhotos, isUpdatingSinglePhoto };
};

export default usePhotoMutationStatus;
